import { render, staticRenderFns } from "./CheckoutHeader.vue?vue&type=template&id=33d420ce&lang=pug"
var script = {}
import style0 from "./CheckoutHeader.vue?vue&type=style&index=0&id=33d420ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports